import React from 'react';
import { Button, Container, Modal } from 'react-bootstrap';
import SectionTitle from '../../components/SectionTitle';
import Main from '../../components/Main';
import Section from '../../components/Section';
import { isBooleanTrue, isListNotEmpty, isObjectNotEmpty, isStringNotEmpty } from '../../utils/objectUtils';
import Agreement from '../../models/Agreement';
import LoadingWrapper from '../../components/LoadingWrapper';
import { useAuth } from '../../redux/ducks/auth';

export const AgreementModalButton = ({ agreementKey, agreementName, buttonText = 'Agreement', className }) => {
    //#region useStates

    const [showModal, setShowModal] = React.useState(false);

    //#endregion

    return (
        <>
            <a className={className ? "link " + className : "link"} onClick={(e) => { e.preventDefault(); setShowModal(true); }}>
                {isStringNotEmpty(buttonText) ? ' ' + buttonText : ''}
            </a>
            {showModal ? (
                <AgreementModal
                    agreementKey={agreementKey}
                    agreementName={agreementName}
                    showModal={showModal}
                    setShowModal={setShowModal}
                />
            ) : null}
        </>
    );
};

export const AgreementButton = ({ route, buttonText = 'Agreement' }) => {
    return (
        <a href={route} target='_blank'>
            {isStringNotEmpty(buttonText) ? ' ' + buttonText : ''}
        </a>
    );
};

const AgreementModal = ({ agreementKey, agreementName, showModal, setShowModal }) => {
    //#region toggles

    const handleCloseModal = () => {
        setShowModal(false);
    };

    //#endregion
    return (
        <Modal
            show={showModal}
            onHide={handleCloseModal}
            size="xl"
            scrollable={true}
        >
            <Modal.Header closeButton>
                <Modal.Title>{agreementName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <AgreementContent agreementKey={agreementKey} agreementName={agreementName} />
                </Container>
            </Modal.Body>
        </Modal>
    );
};

const AgreementPage = ({ agreementKey, agreementName }) => {
    return (
        <Main id="main">
            <Section id="agreement" className='agreement'>
                <Container>
                    <AgreementContent agreementKey={agreementKey} agreementName={agreementName} />
                </Container>
            </Section>
        </Main>
    );
};

const AgreementContent = ({ agreementKey, agreementName }) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [agreement, setAgreement] = React.useState(null);

    const { profile } = useAuth();

    React.useEffect(() => {
        setIsLoading(true);
        Agreement.getAgreement(agreementKey, profile ?? {}, {}).then((obj) => {
            setAgreement(obj);
        }).finally(() => {
            setIsLoading(false);
        });
    }, [agreementKey]);

    return (
        <div>
            <LoadingWrapper isLoading={isLoading} />
            <SectionTitle title={agreement?.name ?? agreementName} />
            {isObjectNotEmpty(agreement) && isStringNotEmpty(agreement.content) ? (
                <>
                    {isBooleanTrue(agreement.displayEffectiveDate) && isStringNotEmpty(agreement.effectiveDate) ? (
                        <p className="text-center">
                            <strong>Effective Date: {agreement.effectiveDate}</strong>
                        </p>
                    ) : null}
                    {isStringNotEmpty(agreement.updatedDate) ? (
                        <p className="text-center">
                            <strong>Last Modified: {agreement.updatedDate}</strong>
                        </p>
                    ) : null}
                    <span dangerouslySetInnerHTML={{ __html: agreement.content }} />
                </>
            ) : null}
        </div>
    );
};

export const AgreementsModalButton = ({ agreementKeys = [], buttonText = 'Agreements', className }) => {
    //#region useStates

    const [showModal, setShowModal] = React.useState(false);

    //#endregion

    return (
        <>
            <a className={className ? "link " + className : "link"} onClick={(e) => { e.preventDefault(); setShowModal(true); }}>
                {isStringNotEmpty(buttonText) ? ' ' + buttonText : ''}
            </a>
            {showModal ? (
                <AgreementsModal
                    agreementKeys={agreementKeys}
                    showModal={showModal}
                    setShowModal={setShowModal}
                />
            ) : null}
        </>
    );
};

const AgreementsModal = ({ agreementKeys = [], showModal, setShowModal }) => {
    //#region toggles

    const handleCloseModal = () => {
        setShowModal(false);
    };

    //#endregion
    return (
        <Modal
            show={showModal}
            onHide={handleCloseModal}
            size="xl"
            scrollable={true}
        >
            <Modal.Body>
                <Container>
                    <AgreementsContent agreementKeys={agreementKeys} />
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

const AgreementsContent = ({ agreementKeys = [] }) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [agreements, setAgreements] = React.useState([]);

    React.useEffect(() => {
        setIsLoading(true);
        Agreement.getAgreements(agreementKeys, null, null).then((list) => {
            setAgreements(list);
        }).finally(() => {
            setIsLoading(false);
        });
    }, [agreementKeys]);

    return (
        <div>
            <LoadingWrapper isLoading={isLoading} />
            {isListNotEmpty(agreements) ? agreements.map((agreement) => {
                return (
                    <div key={`agreement-${agreement.key}`} className="mb-5">
                        <SectionTitle title={agreement.name} />
                        {isBooleanTrue(agreement.displayEffectiveDate) && isStringNotEmpty(agreement.effectiveDate) ? (
                            <p className="text-center">
                                <strong>Effective Date: {agreement.effectiveDate}</strong>
                            </p>
                        ) : null}
                        {isBooleanTrue(agreement.displayUpdatedDate) && isStringNotEmpty(agreement.updatedDate) ? (
                            <p className="text-center">
                                <strong>Last Modified: {agreement.updatedDate}</strong>
                            </p>
                        ) : null}
                        <div dangerouslySetInnerHTML={{ __html: agreement.content }} />
                    </div>
                );
            }) : null}
        </div>
    );
};

export default AgreementPage;